import api from 'services/api';
import { Report } from './types';

const PREFIX = 'reports';

type ReportQueryParams = {
  search?: string;
};

type ListReportRespose = {
  results: Report[];
};

type DataReportRespose = {
  results: Report[];
  total_pages: number;
  count: number;
};

class ReportService {
  endpoint: string;

  constructor() {
    this.endpoint = 'sql_reports';
  }

  list = async (params: ReportQueryParams): Promise<ListReportRespose[]> => {
    const response = await api.get(`${PREFIX}/${this.endpoint}`, {
      params,
    });

    return response.data;
  };

  get = async (id: number): Promise<Report> => {
    const response = await api.get(`${PREFIX}/${this.endpoint}/${id}`);

    return { ...response.data, sql: atob(response.data.sql) };
  };

  data = async (id: number, params: any): Promise<DataReportRespose> => {
    const response = await api.get(`${PREFIX}/${this.endpoint}/${id}/data`, {
      params,
    });

    return response.data;
  };

  create = async (data: { name: string; sql: string }): Promise<Report> => {
    const response = await api.post(`${PREFIX}/${this.endpoint}`, {
      ...data,
      sql: btoa(data.sql),
    });

    return response.data;
  };

  update = async (
    id: number,
    data: { name: string; sql: string }
  ): Promise<Report> => {
    const response = await api.patch(`${PREFIX}/${this.endpoint}/${id}`, {
      ...data,
      sql: btoa(data.sql),
    });

    return response.data;
  };

  delete = async (id: number): Promise<null> => {
    const response = await api.delete(`${PREFIX}/${this.endpoint}/${id}`);

    return response.data;
  };
}

export default new ReportService();
